import * as React from "react";
const SvgFiRrSignalStream = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-signal-stream_svg__a)">
      <path
        fill="#062147"
        d="M12 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m8.49 10.49c4.68-4.68 4.68-12.29 0-16.97a.996.996 0 1 0-1.41 1.41c3.9 3.9 3.9 10.24 0 14.14a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29zm-3.54-3.54A6.96 6.96 0 0 0 19 12c0-1.87-.73-3.63-2.05-4.95a.996.996 0 1 0-1.41 1.41C16.48 9.4 17 10.66 17 12s-.52 2.59-1.46 3.54a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29zM4.93 20.49a.996.996 0 0 0 0-1.41c-3.9-3.9-3.9-10.24 0-14.14a.996.996 0 1 0-1.41-1.41c-4.68 4.66-4.68 12.28-.01 16.96.2.2.45.29.71.29s.51-.1.71-.29m3.54-3.54a.996.996 0 0 0 0-1.41 5.003 5.003 0 0 1 0-7.07.996.996 0 1 0-1.41-1.41 7.007 7.007 0 0 0 0 9.9c.2.2.45.29.71.29s.51-.1.71-.29z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-signal-stream_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSignalStream;
